<template>
  <!-- 薪酬查看  -->
  <div class="dashboard-container">
    <el-tabs v-model="activeName" @tab-click="handleClicks" type="border-card">
        <el-tab-pane label="销售" name="销售" >
            <BaseSalaryPlanType  v-if="activeName === '销售'"    types="销售"   ref="BaseSalaryPlanType"></BaseSalaryPlanType>
        </el-tab-pane>
        <el-tab-pane label="规划师" name="规划师">
            <BaseSalaryPlanType  v-if="activeName === '规划师'"  types="规划师"   ref="BaseSalaryPlanType" ></BaseSalaryPlanType>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import apiBaseUrl from "../../config/api";
import salaryDialog from "./salaryEdit.vue"
import BaseSalaryPlanType from "./BaseSalaryPlanType.vue"
import CourseSalesStatisticsDetails from "./CourseSalesStatisticsDetails.vue"
import SalaryTypeDetails from "./SalaryTypeDetails_copy.vue"
import axios from "axios";
import { getgetListCount, getListSalaryssNew, getListSalarysNew } from "@/api/salaryapi"


 // 获取当前日期
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月份从0开始

    // 补零函数
    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    // 当前月第一天
    const firstDay = `${year}-${pad(month)}-01`;
    // 当前月最后一天
    const lastDay = new Date(year, month, 0).getDate();
    const currentDay = `${year}-${pad(month)}-${pad(lastDay)}`;

export default {
  components: {
    salaryDialog,
    BaseSalaryPlanType,
    CourseSalesStatisticsDetails,
    SalaryTypeDetails,
  },
  data () {
    return {
      activeName: '销售',
      isShowDialog: false,
      editOrview: true,
      formState: {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
        basicClassNum: "",
      },
      totalNum: 0,
      salaryList: [],
      parentTeacherId: "",
      ShowCourseSalesStatisticsDetails:false,
      TimeList:[ firstDay, currentDay ],
      DetailsRow:{},

      lePersList: [
        // { name: "在职", value: 1 },
        // { name: "离职", value: 2 },
        // { name: "请假", value: 3 },
        // { name: "休假", value: 4 },


        { name: "未确认", value: 0 },
        { name: "已确认", value: 1 },
        // { name: "复核中", value: 3 },
      ],

      lePersList1:[],

      summaryData: {
        actualWages: 0, 
        performance: 0, 
        monthSalary:0,
        payableWages:0,
        commission:0,
        subsidy:0,
        socialSecurity:0,
        monthRefund:0,
        reward:0,
        validAmount:0,
        deduction:0,
        performanceAmount:0,
        notReachAmount:0,
        refundCommission:0,
        totalCommission:0, 
        renewalAmount:0,
        classSalesAmount:0,
        classSalesCommission:0,
        renewalCommission:0
      },

    }
  },
  created () {
    // this.getList();
  },

  mounted () {

    this.lePersList1 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
  

    setTimeout(() => {
      this.$nextTick(() => {
         this.getList();
      });
    }, 0);
  },
  methods: {

    handleClicks(e){
        this.activeName = e.name;
    },

     // 合计行内容
    getSummaries({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          // 前3列不展示
          if (index === 1) {
            sums[index] = '汇总';
          } 
          else if (column.property && this.summaryData[column.property] !== undefined) {
            sums[index] = this.summaryData[column.property];
          } else if (data.length === 0 && index >= 2) {
            // 没有数据时也展示“总计：”
            sums[index] = '';
          } else {
            sums[index] = '';
          }
        });
        return sums;
    },
    // 合并前3列
    tableSpanMethod({ rowIndex, columnIndex }) {
      // 最后一行（合计行）合并前3列
      if (rowIndex === this.salaryList.length && columnIndex === 0) {
        return [1, 4]; // 合并1行3列
      }
      if (rowIndex === this.salaryList.length && (columnIndex === 1 || columnIndex === 2)) {
        return [0, 0]; // 被合并的单元格
      }
    },



    handleEmitButs  (event) {
        this.ShowCourseSalesStatisticsDetails = event
    },

    count () {
      let data = {
        salaryYear: this.formState.salaryYear,
        salaryMonth: this.formState.salaryMonth
      }
      axios
        .post(`${apiBaseUrl}/salary/calculate`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            // this.$message.success(res.data.message)
            this.getList()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getList () {
      let data = {
        pageNo: this.formState.pageNum,
        pageSize: this.formState.pageSize,
        projectTeacherId: this.formState.teacherName ? this.formState.teacherName : '',
        // state: this.formState.basicClassNum ? this.formState.basicClassNum : '',
        yearStr: this.formState.salaryYear ? this.formState.salaryYear : '',
        monthStr: this.formState.salaryMonth ? this.formState.salaryMonth : '',
      } 

      getListSalarysNew(data).then((res) => {
        if (res.code == 200) {
            this.salaryList = res.data.records
            this.totalNum = res.data.total
            // this.formState.pageNum = res.data.current
            // this.$message.success(res.message)
        } else {
          this.salaryList = []
          this.totalNum = 0
          this.$message.error(res.message)
        }
       
      }).catch((error) => {
        console.error(error);
         this.salaryList = []
         this.totalNum = 0
         this.$message.error(error)
      });



      getListSalaryssNew(data).then((res) => {
        if (res.code == 200) {
          this.summaryData = {
            actualWages: res.data.actualSalarySum,
            performance: res.data.performanceSum,
            monthSalary: res.data.salarySum,
            payableWages: res.data.totalSalarySum,
            commission: res.data.commissionSum,
            subsidy: res.data.subsidySum,
            socialSecurity: res.data.socialSecuritySum,
            monthRefund: res.data.refundSum,
            reward: res.data.rewardSum,
            validAmount: res.data.amountSum,
            deduction: res.data.deductionSum,
            performanceAmount: res.data.performanceAmountSum, 
            notReachAmount: res.data.notReachAmountSum,
            refundCommission: res.data.refundCommissionSum,
            totalCommission: res.data. totalCommissionSum, 
            renewalAmount: res.data.renewalAmountSum,
            classSalesAmount: res.data.classSalesAmountSum,
            classSalesCommission: res.data.classSalesCommissionSum,
            renewalCommission: res.data.renewalCommissionSum,
            
          }; 
        } else {
          this.summaryData = {
              renewalCommission:0,
              classSalesCommission:0,
              classSalesAmount:0,
              actualWages: 0, 
              renewalAmount: 0,
              performance: 0, 
              monthSalary:0,
              payableWages:0,
              commission:0,
              subsidy:0,
              socialSecurity:0,
              monthRefund:0,
              reward:0,
              validAmount:0,
              deduction:0,
              performanceAmount:0,
              notReachAmount:0,
              refundCommission:0,
              totalCommission:0, 
          };
        }

         this.$nextTick(() => {
            if (this.$refs.salaryTable) {
              this.$refs.salaryTable.doLayout();
            }
         });

      }).catch((error) => {
        this.summaryData = {
            actualWages: 0, 
            performance: 0, 
            monthSalary:0,
            payableWages:0,
            commission:0,
            subsidy:0,
            socialSecurity:0,
            monthRefund:0,
            reward:0,
            validAmount:0,
            deduction:0,
            performanceAmount:0,
            notReachAmount:0,
            refundCommission:0,
            totalCommission:0, 
        };
        this.$message.error(error)
      });


    },
    seachRest1(){
      let data = {  teacherName: this.formState.teacherName ? this.formState.teacherName : '', salaryYear: this.formState.salaryYear ? this.formState.salaryYear : '',  salaryMonth: this.formState.salaryMonth ? this.formState.salaryMonth : '', }
      axios.post(`${apiBaseUrl}//salary/exportTeacherSalary`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.status == 200){
             const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
             const downloadLink = document.createElement("a");
             downloadLink.href = URL.createObjectURL(blob);
             downloadLink.download = "薪酬模板.xlsx";
             downloadLink.click();
             this.$message.success('导出成功')
         }
         else{
            this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
         }
      })
    },

    countBottom(){
      let data = { 
        salaryYear: this.formState.salaryYear,     //年 yyyy格式
        salaryMonth: this.formState.salaryMonth,       //月 MM格式 
      }
      axios.post(`${apiBaseUrl}/salaryPlan/salaryIssue`, data, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.status == 200){
             this.$message.success('发放成功')
         }else{
            this.$message.error("发放失败!");
         }
      }).catch((error) => {
        this.$message.error(error)
      })
    },

    editInfo1Coot(row){
      axios.get(`${apiBaseUrl}/salaryPlan/salaryAnew?id=${row.id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}) .then((res) => {
        if (res.data.code == 200) {
          //  this.$message.success(res.data.message)
        }else{
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        this.$message.error(error)
      });
    },


    editInfo1(row, val){
        this.DetailsRow = row
        this.ShowCourseSalesStatisticsDetails = true
    },
    editInfo (row, val) {
      // this.isShowDialog = false
      if (val == "查看") {
        this.editOrview = false
      } else {
        this.editOrview = true
      }
      console.log(row);
      this.isShowDialog = true
      this.parentTeacherId = row.id
      // this.$refs.salaryMoudel.openDialogChild()

    },
    seachClear () {
      this.formState = {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
        basicClassNum: "",
      }
      this.getList()
    },
    seachRest () {
      console.log(this.formState);
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.formState.pageSize = pageSize;
      this.getList();
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.formState.pageNum = newPage;
      this.getList();
    },
    isShowBtn () {
      this.isShowDialog = false
    },
  }

};
</script>

<style scoped lang="less">
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 7px;
  vertical-align: top;
  margin-bottom: 19px;
}


// ::v-deep.el-form-item__label {
//   text-align: right;
//   vertical-align: middle;
//   float: left;
//   font-size: 14px;
//   color: #606266;
//   line-height: 40px;
//   padding: 0 5px 0 0 !important;
//   box-sizing: border-box;
// }


/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  // #aa>>>.el-dialog {
  //   width: 70% !important;
  // }
}
 .btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

/deep/  .is-leaf{
  text-align: center !important;
}

/deep/ .el-table__cell{
    text-align: center !important;
}

</style>



// WEBPACK FOOTER //
// src/SalescompensationAll/BaseSalaryPlan.vue